/* Gruppiert Events nach Kalendermonat und sortiert sie chronologisch. */
(function () {
  var list = document.querySelector('[data-calendar-rows]');
  if (!list || list.classList.contains('is-grouped')) return;

  var monthFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    timeZone: 'UTC'
  });

  var now = new Date();
  var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

  function eventDate(row) {
    var start = (row.getAttribute('data-event-start') || '').trim();
    var isoDate = start.match(/^(\d{4})-(\d{2})-(\d{2})/);
    var parsedStart = Date.parse(start);

    if (isoDate) {
      var isoDay = Date.UTC(Number(isoDate[1]), Number(isoDate[2]) - 1, Number(isoDate[3]));
      return {
        key: isoDate[1] + '-' + isoDate[2],
        time: Number.isNaN(parsedStart)
          ? isoDay
          : parsedStart,
        day: isoDay,
        title: monthFormatter.format(Date.UTC(Number(isoDate[1]), Number(isoDate[2]) - 1, 1))
      };
    }

    if (!Number.isNaN(parsedStart)) {
      var parsedDate = new Date(parsedStart);
      var year = parsedDate.getUTCFullYear();
      var month = parsedDate.getUTCMonth();
      return {
        key: year + '-' + String(month + 1).padStart(2, '0'),
        time: parsedStart,
        day: Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate()),
        title: monthFormatter.format(Date.UTC(year, month, 1))
      };
    }

    return {
      key: 'undated',
      time: Number.POSITIVE_INFINITY,
      day: Number.POSITIVE_INFINITY,
      title: 'TBA'
    };
  }

  var entries = Array.prototype.slice.call(list.querySelectorAll('.event-row'))
    .map(function (row, index) {
      return {
        row: row,
        index: index,
        date: eventDate(row)
      };
    })
    .sort(function (a, b) {
      return a.date.time - b.date.time || a.index - b.index;
    });

  var upcomingEntries = entries.filter(function (entry) {
    return entry.date.day >= today;
  });
  var pastEntries = entries.filter(function (entry) {
    return entry.date.day < today;
  }).sort(function (a, b) {
    return b.date.time - a.date.time || a.index - b.index;
  });

  var groups = {};
  upcomingEntries.forEach(function (entry) {
    if (!groups[entry.date.key]) {
      var section = document.createElement('section');
      section.className = 'calendar-month';
      section.setAttribute('data-calendar-month', entry.date.key);

      var title = document.createElement('h2');
      title.className = 'calendar-month__title';
      title.textContent = entry.date.title;

      var events = document.createElement('div');
      events.className = 'calendar-month__events';

      section.appendChild(title);
      section.appendChild(events);
      list.appendChild(section);
      groups[entry.date.key] = events;
    }

    groups[entry.date.key].appendChild(entry.row);
  });

  if (pastEntries.length) {
    var pastSection = document.createElement('section');
    pastSection.className = 'calendar-month calendar-month--past';
    pastSection.setAttribute('data-calendar-month', 'past');

    var pastTitle = document.createElement('h2');
    pastTitle.className = 'calendar-month__title';
    pastTitle.textContent = 'Past Events';

    var pastEvents = document.createElement('div');
    pastEvents.className = 'calendar-month__events';

    pastEntries.forEach(function (entry) {
      pastEvents.appendChild(entry.row);
    });

    pastSection.appendChild(pastTitle);
    pastSection.appendChild(pastEvents);
    list.appendChild(pastSection);
  }

  list.classList.add('is-grouped');
})();
